<template>
    <div class="recharge-msg">
        <el-steps :active="stepActive" finish-status="success" align-center class="step-instruct">
            <el-step title="选择用户"></el-step>
            <el-step title="编辑消息"></el-step>
            <el-step title="消息发送"></el-step>
        </el-steps>

        <div v-if="stepActive==0" class="step-content step-user">
            <table class="user-table">
                <!--表头-->
                <tbody>
                    <tr class="tb-title">
                        <th class="tb-checkbox">
                            <el-checkbox @change="allUserSelectHandle" v-model="alluserselect" :indeterminate="allindeterminate"></el-checkbox>
                        </th>
                        <th>用户信息</th>
                        <th>部门</th>
                        <th>职位</th>
                        <th>手机号</th>
                    </tr>
                </tbody>

                <!--内容-->
                <div class="tb-content">
                    <tbody v-for="group in showUserTable" :key="group.id">

                        <!--公司栏-->
                        <tr :class="['tb-context','open','company-row','company-'+group.id]" @click="userPackUp(group)">
                            <td class="tb-checkbox">
                                <el-checkbox @change="groupSelectHandle" v-model="group.checked" :indeterminate="group.indeterminate"></el-checkbox>
                            </td>
                            <td colspan="4" class="company-col">
                                <div class="company">
                                    <div class="company-name">{{group.name}}</div>
                                    <div class="tb-select" @click="e=>userPackUp(group,e)">
                                        <i class="el-icon-caret-bottom"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <!--用户栏-->
                        <tr class="tb-context user-row" v-for="user,index in group.children" :key="user.WxOpenid">

                            <td class="tb-checkbox" :rowspan="group.children.length" v-if="index==0&&group.show"></td>

                            <td class="name-merge" v-if="group.show">
                                <div class="tb-checkbox">
                                    <el-checkbox @change="userSelectHandle" v-model="user.checked"></el-checkbox>
                                </div>
                                <div class="tb-name">
                                    {{user.UserRealName}}
                                </div>
                            </td>

                            <td v-if="group.show">{{user.UserCompanyBranch}}</td>
                            <td v-if="group.show">{{user.UserJob}}</td>
                            <td v-if="group.show">{{user.UserPhone}}</td>
                        </tr>
                    </tbody>
                </div>
            </table>
        </div>

        <!--编辑模板-->
        <div v-if="stepActive==1" class="step-content editortemplate">
            <div class="example template-item">
                <div class="title">示例：</div>
                <div class="content">
                    {{selectTemplate.example}}
                </div>
                <!-- <div class="detail">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                </div> -->
            </div>
            <div class="editor template-item">
                <div class="title">内容：</div>
                <div class="content" v-html="selectTemplate.content">
                    {{selectTemplate.content}}
                </div>
                <!-- <div class="detail">
                    <input type="text" placeholder="请输入详情页跳转的url地址" data-key="url" class="template-input url"/>
                    <i class="el-icon-arrow-right"></i>
                </div> -->
            </div>
        </div>
        <!--预览-->
        <div class="notifys step-content" v-if="stepActive==2">
            <div v-html="sendMsgHtml" class="sendmsghtml template-item"></div>
        </div>
        <!--发送成功-->
        <div class="step-content" v-if="stepActive==3">
            <div class="success-msg">发送成功<i class="el-icon-check"></i></div>
        </div>

        <div class="btn-array">
            <el-button type="primary" class="btn" @click="preStep" v-if="stepActive>0&&stepActive<=2">上一步</el-button>
            <el-button type="primary" class="btn" @click="nextStep" v-if="stepActive<2">下一步</el-button>
            <el-button type="primary" class="btn" @click="sendMsg" v-if="stepActive==2">发送</el-button>
            <el-button type="primary" class="btn" @click="reSendMsg" v-if="stepActive==3">重新发送</el-button>
        </div>

    </div>
</template>

<script>
import _find from "lodash/find";

import {getDatabaseUser,sendWxMsg} from "@api/billing.js"

export default {
    name:"rechargemsg",
    props:["template"],
    data() {
      return {
        stepActive:0, // 激活步骤

        alluserselect:false, // 全部用户是否选中
        allindeterminate:false, // 半选状态
        showUserTable:[], // 用户显示信息表格

        sendMsgHtml:"", // 发送的html示例内容
      }
    },
    computed:{
        selectTemplate(){
            if(this.template){
                // 显示模板示例
                var template=this.template;
                // 处理内容
                var content=template.content;
                var re = /{{(.*?).DATA}}/ig;    
                var r = "";   
                while((r = re.exec(content))) {   
                    var a=r[0]; // 全部的字符串
                    var b=r[1]; // 名称
                    content=content.replace(a,'<input type="text" placeholder="请输入内容" data-key="'+b+'" class="template-input '+b+'"></input>');
                }
                template.content=content;
                return template;
            }   
            return null
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            this.getUserList();
        },
        // 获取用户列表
        getUserList(){
            getDatabaseUser().then(res=>{
                if(res.status&&res.status==200){
                    let users=res.content;
                    let userTable=[];
                    // 数据处理
                    for(let user of users){
                        // console.log(user);
                        let UserCompany=user.UserCompany;
                        let oriUser=_find(userTable, function(o) { return o.name==UserCompany; });
                        if(!oriUser){
                            oriUser={
                                id:UserCompany,
                                name:UserCompany,
                                checked:false,
                                indeterminate:false, // 半选状态
                                children:[],
                                show:true, // 分组是否显示
                            }
                            userTable.push(oriUser);
                        }

                        // 添加新的用户
                        let tempUser={
                            "WxOpenid":user.WxOpenid,
                            "UserRealName":user.UserRealName,
                            "UserCompanyBranch":user.UserCompanyBranch,
                            "UserJob":user.UserJob,
                            "UserPhone":user.UserPhone,
                            checked:false,
                        }
                        oriUser.children.push(tempUser);
                    }
                    // 触发更新
                    this.showUserTable=userTable;
                }
            });
        },
        // 用户收起
        userPackUp(group,e){
            let id=group.id;
            let companyDiv=document.querySelector('.tb-content .company-'+id);

            if(companyDiv.classList.contains("open")){
                this.$set(group,"show",false);
                // 关闭
                companyDiv.classList.remove("open");
            }else{
                this.$set(group,"show",true);
                // 打开
                companyDiv.classList.add("open");
            }
            // 取消引用
            companyDiv=null;

            // 阻止冒泡
            if(e){
                e.stopPropagation();
            }
        },
        // 用户选中处理事件
        userSelectHandle(){
            // 全部用户选中
            let users=this.showUserTable;
            let userNumber=0;
            let userAllSelectNumber=0;
            // 遍历是否选中用户
            for(let group of users){
                let userSelectNumber=0;
                for(let user of group.children){
                    if(user.checked){
                        userSelectNumber++;
                        userAllSelectNumber++;
                    }
                    userNumber++;
                }
                // 全选
                if(userSelectNumber==group.children.length){
                    group.checked=true;
                    group.indeterminate=false;
                }else if(userSelectNumber==0){ // 全不选
                    group.checked=false;
                    group.indeterminate=false;
                }else{ // 选择一部分
                    group.checked=false;
                    group.indeterminate=true;
                }
            }
            this.showUserTable=users;

            // 判断全部用户是否需要选中
            if(userAllSelectNumber==userNumber){
                this.alluserselect=true;
                this.allindeterminate=false;
            }else if(userAllSelectNumber==0){ // 全不选
                this.alluserselect=false;
                this.allindeterminate=false;
            }else{ // 选择一部分
                this.alluserselect=false;
                this.allindeterminate=true;
            }

        },
        // 用户分组处理事件
        groupSelectHandle(){
            // 全部用户选中
            let users=this.showUserTable;
            let userGroupSelectNumber=0;
            // 遍历是否选中用户
            for(let group of users){
                if(group.checked){
                    userGroupSelectNumber++;
                    for(let user of group.children){
                        user.checked=true;
                    }
                }else{
                    for(let user of group.children){
                        user.checked=false;
                    }
                }
            }

            // 全选
            if(userGroupSelectNumber==users.length){
                this.alluserselect=true;
                this.allindeterminate=false;
            }else if(userGroupSelectNumber==0){ // 全不选
                this.alluserselect=false;
                this.allindeterminate=false;
            }else{ // 选择一部分
                this.alluserselect=false;
                this.allindeterminate=true;
            }

            this.showUserTable=users;
        },
        // 全部用户选中
        allUserSelectHandle(value){
            // 全部用户选中
            let users=this.showUserTable;
            this.allindeterminate=false; // 全部用户半选状态
            if(value){
                for(let group of users){
                    group.checked=true;
                    group.indeterminate=false;
                    for(let user of group.children){
                        user.checked=true;
                    }
                }
            }else{ // 全部用户不选
                for(let group of users){
                    group.checked=false;
                    group.indeterminate=false;
                    for(let user of group.children){
                        user.checked=false;
                    }
                }
            }
            this.showUserTable=users;
        },

        // 检查是否有选中用户
        checkUserSelected(){
            // 全部用户选中
            let users=this.showUserTable;
            let userSelected=[]; // 选择的用户列表
            // 遍历是否选中用户
            for(let group of users){
                for(let user of group.children){
                    if(user.checked){
                        userSelected.push(user);
                    }
                }
            }
            return userSelected;
        },

        // 下一步
        nextStep(){
            let step=this.stepActive;
            switch(step){
                case 0: // 获取用户
                    let userSelected=this.checkUserSelected();
                    // 判断是否有选中的人
                    if(userSelected.length<=0){
                        this.$message({
                            message:"请选择通知通知人",
                            type:"warning"
                        });
                        return;
                    }
                    this.stepActive=1;
                    break;
                case 1: // 编辑模板
                    if(!this.template){
                        this.$message({
                            message:"请选择通知模板",
                            type:"warning"
                        });
                        return;
                    }
                    // 获取编辑结果
                    var $editortemplate=this.$el.querySelector(".editortemplate");
                    var $editor=$editortemplate.querySelector(".editor");
                    // 获取标题
                    var title=$editor.querySelector(".title");
                    title.innerHTML="发送内容：";
                    // 获取全部的输入框
                    var inputList=$editor.querySelectorAll("input");
                    var innerHtml=$editor.innerHTML;
                    for(var itn of inputList){
                        var value=itn.value;
                        var itnHtm=itn.outerHTML;
                        var key=itn.dataset['key'];
                        // 进行替换
                        if(value){
                            innerHtml=innerHtml.replace(itnHtm,"<span class='senditem "+key+"' data-key='"+key+"'>"+value+"</span>");
                        }else{
                            // if(key=="url"){
                            //     innerHtml=innerHtml.replace(itnHtm,"<span class='senditem blankmsg "+key+"' data-key='"+key+"'>详情</span>");
                            // }else{
                                innerHtml=innerHtml.replace(itnHtm,"<span class='senditem blankmsg "+key+"' data-key='"+key+"'>内容未填写</span>");
                            // }
                        }
                    }
                    // 渲染新的节点
                    $editor.innerHTML=innerHtml;
                    this.sendMsgHtml=innerHtml;

                    this.stepActive=2;
                    break;
            }
        },
        // 上一步
        preStep(){
            if(this.stepActive>0){
                this.stepActive--;
            }
            switch(this.stepActive){
                case 0:
                    if(this.userSelecteds){
                        this.$nextTick(()=>{
                            // 重新进行用户选中
                            this.userSelecteds.forEach(row => {
                                this.$refs.userTable.toggleRowSelection(row);
                            });
                        })
                    }
                    break;
            }
        },
        // 发送消息
        sendMsg(){
            // 获取模板信息
            var template=this.template;
            // 模板不存在
            if(!template){
                return;
            }

            //构建模板参数
            var $template=this.$el.querySelector(".sendmsghtml");
            var itemList=$template.querySelectorAll(".senditem");
            var sendjson={};
            for(var itm of itemList){
                var key=itm.dataset['key'];
                var value=itm.innerHTML;
                sendjson[key]=value;
            }

            // 发送人员
            let users=[];
            let userSelecteds=this.checkUserSelected();
            for(var item of userSelecteds){
                var userid=item.WxOpenid;
                users.push(userid);
            }

            // 发送微信通知
            sendWxMsg(template.id,template.title,JSON.stringify(sendjson),users.join(",")).then(res=>{
                if(res.status&&res.status==200){
                    this.$notify({
                        title: '成功',
                        message: res.message||'用户消息发送成功',
                        type: 'success'
                    });
                    // 发送成功
                    this.stepActive=3;
                }
                // 部分消息未发送
                if(res.status&&res.status==202){

                }
            });
        },
        // 重新发送
        reSendMsg(){
            // 清空选中
            this.allUserSelectHandle(false);

            this.stepActive=0;
        }
    }
}
</script>

<style lang="scss" scoped>
.recharge-msg{
    .step-instruct {
        border: 1px solid #eee;
        padding: 20px;
        border-radius: 5px;
    }
    .step-content{
        min-height: 250px;
        margin-top: 20px;
    }

    /** 用户表格 */
    .user-table{
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        cursor: default;
        border: none;
        
        table,tbody{
            display:table;
            width:100%;
            table-layout:fixed;
            border-collapse: collapse;
            border-spacing:0;
            empty-cells:hide;
        }

        tbody tr th:first-child,tbody tr td:first-child{
            width:50px;
            border-bottom: none;
        }

        .tb-content{
            height: 260px;
            overflow-x: hidden;
        }
        tbody tr:first-child{
            border-top: none;
        }

        .tb-title>th {
            font-weight: 300;
            text-align: center;
            padding: 10px 0 10px 0;
            background-color: rgb(78, 132, 255);
            color: #efefef;
        }
        th, td,tr {
            border: 1px solid #eee; 
            border-collapse:collapse;   
        }

        tbody tr:last-child{
            border-bottom: none;
            td{
                border-bottom: none;
            }
        }

        tbody:last-child tr:last-child{
            border-bottom: 1px solid #eee;
        }

        td{
            text-align: center;
            padding: 6px 0 6px 0;
        }

        .tb-checkbox{
            text-align: center;
        }


        .tb-context{
    
            .company-col{
                padding: 0;

                .company{
                    text-align: left;

                    display: flex;

                    .company-name{
                        flex: 1;
                        padding: 6px;
                    }

                    .tb-select{
                        width: 50px;
                        position: relative;
                        text-align: center;
                        cursor: pointer;

                        i{
                            top: 50%;
                            position: relative;
                            transform: translateY(-50%);
                        }
                    }
                }

            }

            .name-merge{
                display: flex;
                padding: 0;
                width: auto!important;
                border: none;

                .tb-checkbox{
                    width: 50px;
                    border-right: 1px solid #eee;
                    padding:6px 0;
                }

                .tb-name{
                    flex: 1;
                    padding:6px 0;
                }
            }
        }

        .company-row{
            cursor: pointer;
        }

        
    }
    .user-table:first-child{
        margin-top: 20px;
    }


    .btn-array{
        text-align: center;
        margin-top: 15px;

        ::v-deep  .btn{
            span {
                cursor: pointer;
            }
        }
    }

    /** 通知 */
    .editortemplate,.notifys{
        text-align: center;
        .template-item{
            text-align: left;
            width:250px;
            display: inline-block;
            margin-right: 50px;
            font-size: 16px;

            .title{
                font-size: 20px;
                font-weight: 500;
                margin-bottom: 5px;
            }

            .content{
                min-height: 100px;
                border:1px solid #aaa;
                white-space: pre-line;
                word-break: break-all;
                padding: 10px;
            }
            .detail{
                border:1px solid #aaa;
                border-top:none;
                padding:10px;
                cursor: pointer;
                min-height: 40px;

                .el-icon-arrow-right{
                    float: right;
                    vertical-align: middle;
                }
            }
        }
    }
    .editortemplate{
        display: flex;
        justify-content: end;

        .example{
            .el-icon-arrow-right{
                transform: translateY(20%);
            }
        }
        ::v-deep .editor{
            .template-input{
                width:100px;
                line-height: 30px;
                border-radius: 3px;
                border:1px solid rgb(31, 152, 223);
                margin-bottom: 5px;
                padding:0 4px;
            }

            .template-input:focus {
                outline:none;
                border: 1px solid red;
            }


            .url{
                width: 200px;
            }
            .el-icon-arrow-right{
                transform: translateY(50%);
            }
        }
    }

    /** 成功通知 */
    .success-msg{
        text-align: center;
        border: 1px solid #17af3d;
        height: 100px;
        width: 130px;
        line-height: 100px;
        border-radius: 50px;
        color: green;
        left: 50%;
        margin-top: 20px;
        position: relative;
        transform: translateX(-50%);

        i{
            margin-left: 10px;
        }

    }
}
</style>